// 말소대행(cancel_requests) 동시 작업 프레즌스 — carPresence.js 의 createPresenceClient 팩토리 재사용.
// 서버 계약(고정): 클라 → 서버 cancel:presence:enter/leave/ping(20s)/list {requestId | requestIds[]}
//                  서버 → 클라 cancel:presence {requestId,users} / cancel:presence:snapshot {requests:{id:users[]}}
// 소켓이 없으면(로그아웃 등) 전부 no-op — 서버 미배포/구 서버에서도 조용히 아무 표시 없음.
import { createPresenceClient } from './carPresence';

var cancelPresence = createPresenceClient({ eventPrefix: 'cancel:presence', idKey: 'requestId', listKey: 'requestIds', snapshotKey: 'requests' });

var enter = cancelPresence.enter;
var leave = cancelPresence.leave;
var createChannel = cancelPresence.createChannel;

export { enter, leave, createChannel };
